require 'angular'
moment = require 'moment'
module.exports = ($scope, $http, $q, $uibModal, $rootScope, $state, $analytics, Api, adverseTermsLists, languages,
  workflowTemplates, countries, project, allWorkflows) ->

  $scope.editReportComplete = () ->
    $rootScope.message = "Your report was successfully updated."

    if $scope.user.hasPermission('workflow.redirect_report_instead_of_start_when_editing')
      $state.go('project', {projectId: project.id})
    else
      $state.go('start')

  $scope.saveProject = (projectNewForm) ->
    projectNewForm.$submitted = true

    if !projectNewForm.$valid
      return

    $scope.$parent.searching = true # disable the button

    requests = []
    if $scope.newNameVariations($scope.workflows) > 0
      requests.push($scope.saveNameVariations($scope.workflows)...)

    if $scope._workflowToSave($scope.project).length > 0
      requests.push($scope.saveWorkflows(project)...)

    $q.all(requests)
      .catch (error) ->
        $scope.error_message = "There was a problem saving your workflow: #{error.statusText}"
      .then $scope.editReportComplete

  $scope.saveWorkflows = (project) ->
    workflows = $scope._workflowToSave(project)
    return (w.$save() for w in workflows)

  $scope.saveNameVariations = (workflows) ->
    workflowsToSave = []
    for workflow in workflows
      if (variation for variation in workflow.simple_names when variation.new).length > 0
        workflowCopy = new Api.Workflow(angular.copy(workflow))
        if workflowCopy.date_of_birth? and typeof workflowCopy.date_of_birth is 'string'
          date_of_birth = moment(workflowCopy.date_of_birth).format("YYYY-MM-DD")
          workflowCopy.date_of_birth =
            from_date: date_of_birth
            to_date: date_of_birth
        workflowsToSave.push(workflowCopy.$update())
    workflowsToSave


  $scope.$parent.isEditProject = true
  $scope.$parent.saveProject = $scope.saveProject
  $scope.$parent.saveWorkflows = $scope.saveWorkflows
  $scope.assignedToSelect = project.owner

  workflows = for workflow in allWorkflows
    workflow.disabled = true
    workflow
  if $state.params.entity
    workflows.push(
      new Api.Workflow
        query: $state.params.entity,
        simple_names: [{'name': $state.params.entity}],
        entity_type: null,
        countries: []
    )


  $scope.setProject(project)
  $scope.setWorkflows(workflows)
